export default "__VITE_ASSET__il_$rZwQ__"